/**
 * 功能列表服务
 */
"use strict";
angular.module("addEditServiceMoudle", [
    "addseatModule" //添加位置    
]).
factory("addEditService", ["$modal", "$q", function($modal, $q) {
    return {      
        addSeat: function(info,toChange) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./planningResource/commandMonitor/mapScheduling/addEdit/service/addseat/addseat_tpl.html",
                windowClass: "addLocation",
                backdrop: false,
                controller: "addseatCtrl",
                resolve: {
                     result: function() {
                        return {
                            MAPCONTROLID: info,
                            toChange:toChange,
                        };
                    },
                }
            });
            modalInstance.result.then(function(data) {
                deffer.resolve(data);
            }, function() {

            });
            return deffer.promise;
        },
        // editSeat: function(info) {
        //     var deffer = $q.defer();
        //     var modalInstance = $modal.open({
        //         templateUrl: "./planningCenter/commandMonitor/mapScheduling/addEdit/service/addseat/addseat_tpl.html",
        //         windowClass: "m-tcbox",
        //         backdrop: false,
        //         resolve: {
        //             item: function() {
        //                 return {
        //                     info: info,
        //                 };
        //             },
        //             // confirmBtn: function() {
        //             //     return confirmBtn;
        //             // }
        //         },
        //         controller: "editseatCtrl"
        //     });
        //     modalInstance.result.then(function(data) {
        //         deffer.resolve(data);
        //     }, function() {

        //     });
        //     return deffer.promise;
        // }
    };
}]);